import styled from 'styled-components';

export const Container = styled.div`
  * {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 300;
  }
  margin-top: 20px;
  text-align: center;
`;
export const Title = styled.h1`
  font-size: 1em;
  text-align: center;
  margin-bottom: 10px;
`;
export const Description = styled.div``;
export const Img = styled.img`
  @media (min-width: 700px) {
    width: 50%;
  }

  width: 100%;
  object-fit: contain;
`;

export const Cf = styled.div`
  a {
    margin-top: 10px;
    color: rgb(230, 158, 33);
    text-decoration: none;
  }
`;
